export function chooseTwo(count) {
  if (!Number.isInteger(count) || count < 2) return 0

  return count * (count - 1) / 2
}

export function pairGroups(values) {
  if (!Array.isArray(values)) return []

  return values.slice(0, -1).map((first, index) => ({
    first,
    pairs: values.slice(index + 1).map((second) => [first, second]),
  }))
}
